import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
  }

  disconnect() {
    document.removeEventListener('click', this.boundHandleClickOutside)
  }

  toggle(event) {
    event.stopPropagation()
    
    // Close all other dropdowns
    document.querySelectorAll('.dropdown-menu.show').forEach(menu => {
      if (menu !== this.menuTarget) {
        menu.classList.remove('show')
      }
    })

    // Toggle this dropdown
    this.menuTarget.classList.toggle('show')

    if (this.menuTarget.classList.contains('show')) {
      // Position the menu
      this.positionMenu()
      // Add click outside listener
      setTimeout(() => {
        document.addEventListener('click', this.boundHandleClickOutside)
      }, 0)
    } else {
      document.removeEventListener('click', this.boundHandleClickOutside)
    }
  }

  positionMenu() {
    const button = this.element.querySelector('.entry-menu-btn')
    const menu = this.menuTarget
    if (!button) return
    
    const rect = button.getBoundingClientRect()
    const menuRect = menu.getBoundingClientRect()
    
    // Position below the button, aligned to the right
    menu.style.top = `${rect.bottom - rect.top + 4}px`
    menu.style.right = '0'
    menu.style.left = 'auto'
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target) && !this.menuTarget.contains(event.target)) {
      this.menuTarget.classList.remove('show')
      document.removeEventListener('click', this.boundHandleClickOutside)
    }
  }

  close() {
    this.menuTarget.classList.remove('show')
    document.removeEventListener('click', this.boundHandleClickOutside)
  }
}

